import moment from 'moment'
import { momentToISOLocalDateTime } from 'utils/date'

export const initialFerryPassageValues = {
  contractorId: null,
  ferryServiceId: null,
  harbourCoordinates: '',
  paymentDate: momentToISOLocalDateTime(moment()),
  price: {
    amount: '',
    currencyCode: 'PLN'
  },
  bunkerAdjustmentFactor: {
    amount: '0',
    currencyCode: 'PLN'
  },
  additionalInfo: ''
}

export function ferryPassageValuesWithContractorSelected (contractorId) {
  return {
    ...initialFerryPassageValues,
    contractorId
  }
}

export function ferryPassageValuesWithFerryServiceSelected(value, ferryService) {
  if (ferryService) {
    return {
      ...initialFerryPassageValues,
      contractorId: ferryService.contractorId,
      ferryServiceId: ferryService.id,
      price: {
        amount: ferryService.price,
        currencyCode: ferryService.currencyCode
      },
      bunkerAdjustmentFactor: {
        amount: ferryService.price * ferryService.bunkerAdjustmentFactor / 100,
        currencyCode: ferryService.currencyCode
      },
      harbourCoordinates: ferryService.harbourLocation.text,
      additionalInfo: ferryService.additionalInfo
    }
  } else {
    return {
      ...initialFerryPassageValues,
      contractorId: value.contractorId
    }
  }
}
